import type { Dialog } from '@docue/docue-ui-v2/ui-components/DTDialog/types'

export default () => {
  const { confirm, confirmDelete } = useDialog()
  const { t } = useI18n()

  const triggerConfirm = (options: Dialog) => confirm({
    okTitle: t('continue'),
    cancelTitle: t('cancel'),
    ...options,
  })

  triggerConfirm.withDelete = (options: Dialog) => confirmDelete({
    okTitle: t('delete'),
    cancelTitle: t('cancel'),
    ...options,
  })

  return {
    triggerConfirm,
  }
}
